exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#login[data-v-14002ff2]{background:url(\"/public/images/site/background-modal-admin.svg\");background-repeat:repeat-x;background-size:1000px;display:table;width:100%;background-position-y:top}.login[data-v-14002ff2]{width:500px;padding-left:20px;padding-right:20px;padding-top:10px;background-color:#e9ecef;border-radius:15px;-webkit-box-shadow:-1px 20px 71px -39px rgba(0,0,0,.75);-moz-box-shadow:-1px 20px 71px -39px rgba(0,0,0,.75);box-shadow:-1px 20px 71px -39px rgba(0,0,0,.75)}.close[data-v-14002ff2]{padding:0;font-size:40px;font-weight:300}.label[data-v-14002ff2]{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14002ff2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/categories/NewCategory.vue
// module id = 528
// module chunks = 0